import React, {Fragment} from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";

/**
 * Ein Dialog zur Darstellung beliebigen Inhalts.
 *
 * @param {stateful} open - stateful value zum Öffnen/Schließen des Dialogs.
 * @param {string} testId - ID used to identify the dialog during testing.
 * @param {component} titleChildren - Der Titel, der in der Kopfzeile angezeigt wird.
 * @param {component} content - Der Inhalt des Dialogs
 * @param {component} buttons - Der oder die Buttons des Dialogs, die in der Fußzeile angezeigt werden.
 * @param {function} closeFunction - Nur wenn dieses Attribut angegeben ist, kann der Dialog per X-Button geschlossen werden. Diese Funktion wird dan von dem X-Button aufgerufen.
 * @param {object} style - Style der an Header, Content und Buttonbar uebergeben wird
 * @returns {JSX.Element}
 * @constructor
 */
function EADialog({open, testId, titleChildren, content, buttons, closeFunction, style = {}}) {
    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
            display: "flex",
        },
        closeButton: {
            padding: "0 0 0 10px",
            margin: "-10px -5px 0 auto",
            color: theme.palette.grey[500],
        },
        header: {
            color: "black",
            fontSize: 13,
        },
    });

    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <div className={classes.header}>{children}</div>
                {onClose ? (
                    <IconButton data-cy={"dialogCloseButton"} aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    return (
        <Dialog PaperProps={{"data-cy": testId}} open={open} maxWidth={"md"}>
            {open && (
                <Fragment>
                    <DialogTitle children={titleChildren} onClose={closeFunction} style={style}/>
                    <DialogContent dividers style={{...style, whiteSpace: "pre-wrap"}}>
                        {content}
                    </DialogContent>
                    <DialogActions style={style}>{buttons}</DialogActions>
                </Fragment>
            )}
        </Dialog>
    );
}

EADialog.propTypes = {
    open: PropTypes.bool.isRequired,
    testId: PropTypes.string,
    titleChildren: PropTypes.node,
    content: PropTypes.node,
    buttons: PropTypes.node,
    closeFunction: PropTypes.func,
};

export default EADialog;
